import { Box } from '@bechtel/gds';
import styled, { css } from 'styled-components';

export const GeneralContainer = styled(Box).attrs({
  flexDirection: { sm: 'column' },
  p: { sm: '500' },
  m: { sm: '300' },
})`
  ${({ theme }) => css`
    background-color: ${theme.colors.white};
    height: 91vh;
    border-radius: 4px;
  `}
`;
